






















































import { Component, Vue,Watch } from 'vue-property-decorator';
import { getExp,detailExp } from '@/api/user/user';
import ECharts from 'vue-echarts/components/ECharts.vue'; // 引用vue-echarts
import 'echarts/lib/chart/radar';
import { goTop } from '@/global/utils';
@Component({
  components: {
    chart: ECharts,
  },
})
export default class Exp extends Vue {
  private columns: object[] = [
    {
      title: '资质类型名称',
      key: 'title',
      align: 'center',
    },
    {
      title: '经验值',
      key: 'experience',
      align: 'center',
      slot: 'experience'
    },
  ];
  private d_colums:object[] = [
    {
      title:'时间',
      key:'ctime',
      align: 'left'
    },
    {
      title:'经验值变化',
      key:'experience',
      align: 'left'
    },
    {
      title:'变化原因',
      key:'desc',
      align: 'left'
    },
    {
      title:'变化结果',
      key:'texperience',
      align:'left'
    }
  ]
  private loading: boolean = true;
  private tableData: object[] = [];
  private detailData: object[] = [];
  private total: number = 0;
  private role_name: string = "";
  private detailTitle :string = "";
  private detailTotal : number = 0;

  private params = {
    page: 1,
    pageSize: 20,
  };

  private d_params = {
    page:1,
    pageSize:20,
    uid:'',
    categoryId:''
  }

  get userId(){
    return this.$store.state.userInfo.id;

  }
  @Watch('userId')
  private userIdChange(to: any, from: any) {
    if(to){
      this.getList(this.params);
    }
  }
  private mounted() {
    this.getList(this.params);
    goTop();
  }
  private async getList(params) {
    if(this.$store.state.userInfo.id){
      this.loading = true;
      // 有uid入参为个人经验值 无则为团队经验值
      let reqData = Object.assign({ uid: this.$store.state.userInfo.id }, params);
      const res: any = await getExp(reqData);
      this.tableData = res ? res.rows : [];
      this.total = res ? res.total : 0;
      this.loading = false;
      this.getRoleName();
    }
  }
  private async getRoleName(){
    if(this.$store.state.userInfo.team_role){
      switch(this.$store.state.userInfo.team_role){
        case 0:
          this.role_name='初级标注员'
          break
        case 1:
          this.role_name='公会会长'
          break
        case 2:
          this.role_name='高级标注员'
          break
        case 3:
          this.role_name='审核员'
          break
        case 4:
          this.role_name='高级审核员'
          break
        case 5:
          this.role_name='小助手'
          break
        case 6:
          this.role_name='质检员'
          break
      }
    }
  }
  private initDetail(title,uid,cid){
    this.detailTitle = title;
    this.detailData = [];
    this.loading = true;
    this.getDetailExp({uid:uid,categoryId:cid})
  }
  public async getDetailExp(params){
    let reqData = Object.assign(this.d_params,params)
    const res:any = await detailExp(reqData)
    this.detailData = res ? res.rows : [];
    this.detailTotal = res? res.total : 0;
    this.loading = false
  }
  public showAll(){
    this.detailTitle = ''
  }
  public changePage(data) {
    this.params = Object.assign(this.params, { page: data });
    this.getList(this.params);
  }
  public changeDetailPage(data) {
    this.params = Object.assign(this.params, { page: data });
    this.getDetailExp(this.params);
  }
}
